import { Clock } from "lucide-react";
import { Link } from "react-router";
import type { ArticleSummary } from "@jipraks/shared";
import { SpotlightCard } from "@client/components/ui/SpotlightCard";
import { formatDate } from "@client/lib/format";
import { blogCopy } from "@client/locales/id/blog";

export function ArticleCard({ article }: { article: ArticleSummary }) {
  return (
    <SpotlightCard className="h-full">
      <Link to={`/blog/${article.slug}`} className="flex h-full flex-col">
        <div className="aspect-video overflow-hidden rounded-t-2xl border-b border-border-default bg-background-elevated">
          {article.imageUrl && (
            <img
              src={article.imageUrl}
              alt={article.imageAlt ?? article.title}
              width={640}
              height={360}
              loading="lazy"
              className="size-full object-cover"
            />
          )}
        </div>
        <div className="flex flex-1 flex-col gap-3 p-5">
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-muted">
            <time dateTime={article.publishedAt}>{formatDate(article.publishedAt)}</time>
            <span className="flex items-center gap-1">
              <Clock className="size-3.5" aria-hidden="true" />
              {blogCopy.readingTime(article.readingMinutes)}
            </span>
          </div>
          <h3 className="line-clamp-2 text-base leading-snug font-semibold tracking-tight text-foreground">
            {article.title}
          </h3>
          {article.excerpt && (
            <p className="line-clamp-3 text-sm leading-relaxed text-foreground-muted">{article.excerpt}</p>
          )}
        </div>
      </Link>
    </SpotlightCard>
  );
}
